import Panel from 'portaltransparencia-common/components/Panel.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';
import PageHeader from '../../components/PageHeader.react.js';
import * as actions from '../Actions.js';
import FormDetailHeader from './FormDetailHeader.react';
import { FormDetailTabs } from './FormDetailTabs.react';
import { TipoEmendaParlamentar } from '../TipoEmendaParlamentar';

export const TITLE = {
  [TipoEmendaParlamentar.MUNICIPAL]: 'Municipal',
  [TipoEmendaParlamentar.FEDERAL]: 'Federal',
  [TipoEmendaParlamentar.ESTADUAL]: 'Estadual'
};

export class FormEmendaContabilidadeDetail extends Component {
  static propTypes = {
    emenda: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    findEmendaById: PropTypes.func.isRequired,
    tipo: PropTypes.oneOf(Object.values(TipoEmendaParlamentar)).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      })
    }).isRequired,
    isIntegradoOxy: PropTypes.bool
  };

  componentDidMount() {
    const { findEmendaById, match } = this.props;
    const { id } = match.params;
    findEmendaById(id);
  }

  render() {
    const { emenda, location, tipo, isIntegradoOxy } = this.props;
    const titleByTipoEmenda = TITLE[tipo];

    return (
      <section>
        <Helmet
          id="helmet"
          title={`Emenda ${titleByTipoEmenda} ${emenda.get('numero')}`}
        />

        <PageHeader
          location={location}
          textoDetalhe={`Emenda ${titleByTipoEmenda}: ${emenda.get('numero')}`}
        />

        <Panel expansible={false}>
          <FormDetailHeader
            emenda={emenda}
            tipo={tipo}
            isIntegradoOxy={isIntegradoOxy}
          />

          <hr className="mt-xs mb-xs" />

          <FormDetailTabs
            emenda={emenda}
            tipo={tipo}
            isIntegradoOxy={isIntegradoOxy}
          />
        </Panel>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    emenda: state.emendaContabilidade.get('emenda'),
    isIntegradoOxy: state.entidade.getIn([
      'configuracoesGerais',
      'isIntegradoOxy'
    ])
  };
}

const allActions = {
  findEmendaById: actions.findEmendaById
};

export default connect(
  mapStateToProps,
  allActions
)(FormEmendaContabilidadeDetail);
